import {
  ApiRequest,
  ApiRequestBlob,
  ApiRequestNoLoder,
} from "../../services/api";

export const GetReportsDownload = async (query) => {
  return await ApiRequestBlob("GET", "admin/get-emp-data?" + query);
};
export const GetReportsData = async (query) => {
  return await ApiRequest("GET", "admin/get-emp-data?" + query);
};

export const GetDownloadPDF = async (query) => {
  return await ApiRequest("GET", "admin/pdf?" + query);
};

export const GetEmailFooter = async () => {
  return await ApiRequest("GET", "admin/email-footer");
};
export const GetClientEmails = async () => {
  return await ApiRequest("GET", "admin/client-emails");
};

export const GetBotStatusData = async () => {
  return await ApiRequest("GET", "admin/bot-run-status");
};

export const GetBotDetails = async (botType) => {
  return await ApiRequest("GET", "admin/bot-details?botType=" + botType);
};

export const GetSuccessMsg = async (startDate, endDate) => {
  const query = `startDate=${encodeURIComponent(
    startDate
  )}&endDate=${encodeURIComponent(endDate)}`;
  return await ApiRequest("GET", "admin/crew-data?" + query);
};
